import { createFileRoute } from "@tanstack/react-router";
import { seo, breadcrumbScript } from "@/lib/seo";
import { LegalPage } from "@/components/app/legal-page";
import { SocialConnectSection } from "@/components/app/social-connect-section";

const DESC =
  "Reach The Quantum Minds by email, Instagram, YouTube or Telegram. We usually respond within 24–48 hours.";

export const Route = createFileRoute("/contact")({
  head: () => ({
    ...seo({
      title: "Contact Us — The Quantum Minds",
      description: DESC,
      path: "/contact",
    }),
    scripts: [
      breadcrumbScript([
        { name: "Home", path: "/" },
        { name: "Contact", path: "/contact" },
      ]),
    ],
  }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <LegalPage title="Contact Us">
      <section className="glass rounded-3xl p-5">
        <p className="text-sm leading-relaxed text-muted-foreground">
          For any queries, technical issues or feedback, contact us through email or our official
          social media handles. We usually respond within 24–48 hours.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          The Quantum Minds is independently operated by Aryan Singh. Payment-related queries are
          handled manually — premium is usually activated within 2 hours after valid payment details
          are submitted, though verification may occasionally take longer.
        </p>
      </section>
      <SocialConnectSection />
    </LegalPage>
  );
}